import React from "react";
import { AlertsTableDensity } from "./AlertsUtils/alertsDensity";

export const AlertsDensityToggle = ({
  density,
  onDensityChange,
}: {
  density: AlertsTableDensity;
  onDensityChange: (density: AlertsTableDensity) => void;
}) => {
  return (
    <div
      className="flex shrink-0 rounded border border-actuate-blue/25"
      role="group"
      aria-label="Table density"
    >
      {(["detailed", "condensed"] as AlertsTableDensity[]).map((option) => {
        const isActive = density === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onDensityChange(option)}
            className={`px-2 py-1 font-mulish text-[11px] font-bold ${
              isActive
                ? "bg-actuate-orange text-white"
                : "bg-white text-actuate-blue"
            }`}
          >
            {option === "detailed" ? "Detailed" : "Condensed"}
          </button>
        );
      })}
    </div>
  );
};
